import { useCallback } from "react";
import { INK, STATUS } from "../../../../theme/tokens";
import { type ThresholdConfig, type ThresholdMode, ThresholdStatus } from "../types";

export const useThresholdStatus = (options: { threshold: ThresholdConfig; mode?: ThresholdMode }) => {
	const { threshold, mode = "higherIsBetter" } = options;

	return useCallback(
		(percentage: number): ThresholdStatus => {
			if (mode === "closestToTarget") {
				const diffFromTarget = Math.abs(percentage - 100);
				if (diffFromTarget < threshold.warning) return ThresholdStatus.GOOD;
				if (diffFromTarget < threshold.error) return ThresholdStatus.WARNING;
				return ThresholdStatus.ERROR;
			}

			if (mode === "higherIsBetter") {
				if (percentage >= threshold.warning) return ThresholdStatus.GOOD;
				if (percentage >= threshold.error) return ThresholdStatus.WARNING;
				return ThresholdStatus.ERROR;
			}

			// lowerIsBetter
			if (percentage <= threshold.warning) return ThresholdStatus.GOOD;
			if (percentage <= threshold.error) return ThresholdStatus.WARNING;
			return ThresholdStatus.ERROR;
		},
		[threshold, mode],
	);
};

export const useStatusColor = (options: { threshold: ThresholdConfig; mode?: ThresholdMode }) => {
	const getStatus = useThresholdStatus(options);

	return useCallback(
		(percentage: number): { status: ThresholdStatus; color: string } => {
			const status = getStatus(percentage);

			let color: string = INK.SECONDARY;
			if (status === ThresholdStatus.GOOD) {
				color = STATUS.SUCCESS.main;
			} else if (status === ThresholdStatus.WARNING) {
				color = STATUS.WARNING.main;
			} else if (status === ThresholdStatus.ERROR) {
				color = STATUS.ERROR.main;
			}

			return { status, color };
		},
		[getStatus],
	);
};
